import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-student-scholarship',
  templateUrl: './student-scholarship.component.html',
  styleUrls: ['./student-scholarship.component.scss']
})
export class StudentScholarshipComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
